import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapComponent } from './map.component';
import { ChartComponent } from './chart.component';
import { StationTableComponent } from './station-table.component';
import { SystemReportsComponent } from './system-reports.component';
import { StationDashboardComponent } from './station-dashboard.component';
import { DashboardTemplateComponent } from './dashboard-template.component';
import { DashboardTemplateHomeComponent } from './dashboard-template-home.component';
import { ImpactTableComponent } from './impact-table.component';
import { ConfigPreferencesComponent } from './config-preferences.component';
import { ManageUsersAddComponent } from './manage-users-add.component';
import { ManageUsersComponent } from './manage-users.component';
import { AuthGuard } from './auth-guard.service';
import { LoginComponent } from './login.component';
import { UserMessageComponent } from './user-message.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: '/map',
		pathMatch: 'full'
	},
	{
		path: 'chart',
		component: ChartComponent
	},
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'map',
		component: MapComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'stationTable',
		component: StationTableComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'systemReports',
		component: SystemReportsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'stationDashboard/:id',
		component: StationDashboardComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'dashboardTemplate',
		component: DashboardTemplateHomeComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'dashboardTemplate/:id',
		component: DashboardTemplateComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'impactTable/:id',
		component: ImpactTableComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'configPreferences',
		component: ConfigPreferencesComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'manageUsers',
		component: ManageUsersComponent,
		canActivate: [AuthGuard],
		data: {permission: 'users.view'}
	},
	{
		path: 'manageUsersAdd',
		component: ManageUsersAddComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'manageUsersAdd/:user',
		component: ManageUsersAddComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'userMessages',
		component: UserMessageComponent,
		canActivate: [AuthGuard]
	}
];

@NgModule({
	imports: [ RouterModule.forRoot(routes) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
